export default __webpack_public_path__ + "static/media/portsaid.ee722321.jpg";